import React from "react";
import "./footer.css";
import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { BsWhatsapp } from "react-icons/bs";

const Footer = () => {
  return (
    <footer>
      <a href="#" className="footer__logo">
        Beauty Planner
      </a>
      <ul className="permalinks">
        <li>
          <a href="#">Inicio</a>
        </li>
        <li>
          <a href="#about">Acerca</a>
        </li>
        <li>
          <a href="#experience">Experiencia</a>
        </li>
        <li>
          <a href="#services">Servicios</a>
        </li>
        <li>
          <a href="#portfolio">Portafolio</a>
        </li>
        <li>
          <a href="#testimonials">Clientes</a>
        </li>
        <li>
          <a href="#contact">Contacto</a>
        </li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.facebook.com/viqii.guajrdo" target="_blank" rel="noreferrer">
          <FaFacebookF />
        </a>
        <a href="https://www.instagram.com/victoriamakeup.ok/?igshid=YmMyMTA2M2Y%3D" target="_blank" rel="noreferrer">
          <FiInstagram />
        </a>
        <a
          href="https://api.whatsapp.com/send?phone=542634692173"
          target="_blank"
          rel="noreferrer"
        >
          <BsWhatsapp />
        </a>
      </div>

      <div className="footer__copyright">
        <small>&copy; Enzo Fiol. All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
